module.exports = __webpack_public_path__ + "static/img/ranking-event-btn.5e016d9.png";